/* eslint-disable prefer-promise-reject-errors */
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Form,
  Input,
  message,
  Result,
  Spin,
  Tooltip,
  Typography
} from 'antd';
import jwt from 'jsonwebtoken';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { CONFIG } from '../constants';
import EmpresaContext from '../context/empresa-context';
import UserContext from '../context/user-context';
import { instanceRef } from '../utils/axios';
import ResponsiveContainer from './ResponsiveContainer';

const { Title } = Typography;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOGIN;

const Recuperar = () => {
  const [loading, setLoading] = useState(false);
  const [codigoEnviado, setCodigoEnviado] = useState(false);
  const { updateUser, updateAccessToken } = useContext(UserContext);
  const { empresa } = useContext(EmpresaContext);
  const [token, setToken] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [tokenExpirable, setTokenExpirable] = useState(null);
  const history = useHistory();
  const params = useParams();
  const styles = {
    container: {
      backgroundColor: CONFIG.COLOR_PRIMARY,
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    card: {
      maxWidth: 460,
      minWidth: 350
    }
  };

  /* const info = () => {
    Modal.info({
      title: 'Instrucciones enviadas',
      content: (
        <div>
          <p>
            Hemos enviado un recordatorio a su dirección de correo electrónico.
            En caso de que no lo haya recibido, le recomendamos verificar que el
            nombre de usuario ingresado esté correctamente escrito y registrado
            como una cuenta válida.
          </p>
        </div>
      ),
      onOk() {}
    });
  }; */

  const checkErrors = (error) => {
    try {
      if (error.response?.data?.message?.code === 'NotAuthorizedException') {
        message.error('Nombre de usuario o contraseña incorrectos');
      } else if (
        error.response?.data?.message?.code === 'CodeMismatchException'
      ) {
        message.error('El código de verificación es inválido');
      } else if (
        error.response?.data?.message?.code === 'LimitExceededException'
      ) {
        message.error(
          'Se superó el límite de intentos. Inténtelo después de un tiempo'
        );
      } else if (
        error.response?.data?.message?.code === 'InvalidPasswordException'
      ) {
        message.error(
          'La contraseña no se ajusta a la política: la contraseña debe tener caracteres en mayúsculas'
        );
      } else {
        message.error(error.response?.data.message);
      }
    } catch (error2) {
      // error
    }
  };

  const login = (values) => {
    setLoading(true);
    instanceRef.instance
      .post('auth/login', { userData: values })
      .then((response) => {
        if (response?.data?.data) {
          const { accessToken, idToken, usuarioSegu } = response.data.data;
          updateAccessToken(accessToken.jwtToken);
          updateUser({ ...idToken.payload, usuarioSegu });
        }
        // Token Expirable pasa a Usado
        instanceRef.instance
          .post('tokenExpirables/update', {
            tokenExpirable: tokenExpirable.token_expirable
          })
          .catch((error) => {
            setLoading(false);
            // eslint-disable-next-line no-console
            console.log(error);
          });
        setLoading(false);
        history.push('/');
      })
      .catch((error) => {
        setLoading(false);
        // eslint-disable-next-line no-console
        console.log(error);
      });
  };

  const onFinish = (values) => {
    setLoading(true);
    const { username, password, confirmationCode } = values;
    const data = {
      username: username || usuario.usuario,
      password,
      confirmationCode
    };

    // Encriptar datos de login con JWT
    const userData = jwt.sign(data, secretKey);
    if (token) {
      instanceRef.instance
        .post('auth/confirm', { userData })
        .then(() => {
          login(userData);
        })
        .catch((error) => {
          setLoading(false);
          checkErrors(error);
        });
    } else {
      instanceRef.instance
        .post('auth/forgot', { userData })
        .then(() => {
          setLoading(false);
          setCodigoEnviado(true);
          // info(username);
          // history.goBack();
        })
        .catch((error) => {
          setLoading(false);
          checkErrors(error);
        });
    }
  };

  const validarToken = async (tokenUsuario) => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.post(
        'tokenExpirables/validar',
        { token: tokenUsuario, modelo: 'usuario' }
      );
      setUsuario(response.data.data.datosRecurso);
      setTokenExpirable(response.data.data.tokenExpirable);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // eslint-disable-next-line no-console
      console.info(error);
    }
  };

  useEffect(() => {
    const tokenUsuario = params.token;
    setToken(tokenUsuario);

    if (tokenUsuario) {
      validarToken(tokenUsuario);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={styles.container}>
      <Spin spinning={loading} delay={500}>
        {!loading && (
          <>
            {!token && !codigoEnviado && (
              <Card style={styles.card}>
                <Form
                  layout="vertical"
                  name="recuperar"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                  size="small"
                >
                  <Title level={4}>Recuperar contraseña</Title>
                  <br />
                  <Form.Item
                    label="Usuario"
                    name="username"
                    rules={[{ required: true, message: 'Campo requerido!' }]}
                  >
                    <Input placeholder="Ingrese su nombre de usuario" />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      style={{ marginTop: 20 }}
                    >
                      Recuperar
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
            {token && tokenExpirable && !tokenExpirable.usado && (
              <Card style={styles.card}>
                <Form
                  layout="vertical"
                  name="recuperar"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                  size="small"
                >
                  <Title level={4}>Recuperar contraseña</Title>
                  <br />
                  <Form.Item
                    label={
                      <span>
                        Nueva Contraseña&nbsp;
                        <Tooltip
                          title={
                            <span>
                              Entre 8 y 99 caractares
                              <br />
                              Al menos una minúscula
                              <br />
                              Al menos una mayúscula
                              <br />
                              Al menos un número
                              <br />
                            </span>
                          }
                        >
                          <QuestionCircleOutlined />
                        </Tooltip>
                      </span>
                    }
                    name="password"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Contraseña es un campo requerido'
                      },
                      () => ({
                        validator(_, value) {
                          const longitud = value?.length || 0;
                          const tieneMinuscula = /(?=.*[a-z])/.test(value);
                          const tieneMayuscula = /(?=.*[A-Z])/.test(value);
                          const tieneNumero = /(?=.*[0-9])/.test(value);
                          // eslint-disable-next-line no-useless-escape
                          // eslint-disable-next-line no-useless-escape
                          const valid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{8,99}$/.test(
                            value
                          );

                          if (longitud <= 0) {
                            return Promise.resolve();
                          }

                          if (!tieneMinuscula) {
                            return Promise.reject(
                              'La contraseña debe contener alguna letra minúscula'
                            );
                          }

                          if (!tieneMayuscula) {
                            return Promise.reject(
                              'La contraseña debe contener alguna letra mayúscula'
                            );
                          }

                          if (!tieneNumero) {
                            return Promise.reject(
                              'La contraseña debe contener algún número'
                            );
                          }

                          if (longitud < 8) {
                            return Promise.reject(
                              'La longitud mínima es de 8 caracteres'
                            );
                          }

                          if (longitud > 99) {
                            return Promise.reject(
                              'La longitud máxima es de 99 caracteres'
                            );
                          }

                          if (valid) {
                            return Promise.resolve();
                          }
                          return Promise.reject('Revisar contraseña');
                        }
                      })
                    ]}
                  >
                    <Input.Password
                      autoComplete="new-password"
                      placeholder="Nueva contraseña"
                    />
                  </Form.Item>

                  <Form.Item
                    name="confirmNewPassword"
                    label="Confirmar nueva contraseña"
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: 'Por favor confirme su contraseña!'
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            'Las dos contraseñas que ingresaste no son iguales'
                          );
                        }
                      })
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>

                  <Form.Item
                    label="Ingrese el código recibido en el correo"
                    name="confirmationCode"
                    rules={[{ required: true, message: 'Campo requerido!' }]}
                  >
                    <Input placeholder="Ingrese su código" />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      size="large"
                      htmlType="submit"
                      style={{ marginTop: 20 }}
                    >
                      Confirmar nueva contraseña
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
            {!token && codigoEnviado && (
              <ResponsiveContainer>
                <Card style={styles.card}>
                  <Result
                    title="Instrucciones enviadas"
                    subTitle="Hemos enviado un recordatorio a su dirección de correo electrónico.
                    En caso de que no lo haya recibido, le recomendamos verificar que el
                    nombre de usuario ingresado esté correctamente escrito y registrado
                    como una cuenta válida."
                    extra={
                      empresa.tiene_landing
                        ? [
                            <Button
                              type="primary"
                              key="console"
                              onClick={() => {
                                window.location.href = `/`;
                              }}
                            >
                              Ir al Inicio
                            </Button>
                          ]
                        : null
                    }
                  />
                </Card>
              </ResponsiveContainer>
            )}
            {token && !tokenExpirable && (
              <ResponsiveContainer>
                <Card style={styles.card}>
                  <Result
                    title="El Token ha expirado"
                    subTitle="El token proporcionado ha expirado para el cambio de contraseña. Por favor, solicite un nuevo token para continuar con el proceso de cambio de contraseña."
                    extra={
                      <Button
                        type="primary"
                        key="console"
                        onClick={() => {
                          window.location.href = `/recuperar`;
                        }}
                      >
                        Solcitar otro
                      </Button>
                    }
                  />
                </Card>
              </ResponsiveContainer>
            )}
            {token && tokenExpirable && tokenExpirable.usado && (
              <ResponsiveContainer>
                <Card style={styles.card}>
                  <Result
                    title="El Token ya fue utilizado"
                    subTitle="El token para el cambio de contraseña ya ha sido utilizado. Por favor, asegúrate de utilizar el enlace más reciente que te hemos proporcionado para restablecer tu contraseña."
                    extra={
                      <Button
                        type="primary"
                        key="console"
                        onClick={() => {
                          window.location.href = `/recuperar`;
                        }}
                      >
                        Solcitar otro
                      </Button>
                    }
                  />
                </Card>
              </ResponsiveContainer>
            )}
          </>
        )}
      </Spin>
    </div>
  );
};

export default Recuperar;
